import { render, staticRenderFns } from "./DlgTrainingNew.vue?vue&type=template&id=0d63e91d&scoped=true"
import script from "./DlgTrainingNew.vue?vue&type=script&lang=ts"
export * from "./DlgTrainingNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d63e91d",
  null
  
)

export default component.exports